/**
 * カート保護機能 - 優先購入期間による自動削除
 *
 * sale-startタグによる優先購入期間中に、対象ランクではないユーザーの
 * カートから該当商品を自動的に削除する機能
 */

(function() {
  'use strict';

  /**
   * カート保護機能の初期化
   */
  const initCartProtection = () => {
    // JSONデータの取得
    const protectionData = getProtectionData();
    if (!protectionData) {
      return;
    }

    // 削除対象商品の判定
    const itemsToRemove = findItemsToRemove(protectionData);
    if (itemsToRemove.length === 0) {
      return;
    }

    // カート削除処理
    removeCartItems(itemsToRemove);
  };

  /**
   * カート保護用のJSONデータを取得
   * @returns {Object|null} 保護データオブジェクト、取得失敗時はnull
   */
  const getProtectionData = () => {
    try {
      const dataElement = document.querySelector('[data-cart-protection-check]');
      if (!dataElement) {
        return null;
      }

      const jsonText = dataElement.textContent;
      if (!jsonText) {
        return null;
      }

      const data = JSON.parse(jsonText);
      return data;
    } catch (error) {
      console.error('カート保護データの取得に失敗しました:', error);
      return null;
    }
  };

  /**
   * 削除対象の商品を判定
   * @param {Object} data - 保護データオブジェクト
   * @returns {Array} 削除対象のlineIndexの配列
   */
  const findItemsToRemove = (data) => {
    const { customerRank, currentTime, items } = data;

    if (!items || !Array.isArray(items)) {
      return [];
    }

    const itemsToRemove = [];

    items.forEach((item) => {
      // 条件1: 優先期間中かチェック
      if (!item.isActive) {
        return;
      }

      // 条件2: 現在時刻が終了時刻より前かチェック（念のための二重チェック）
      if (currentTime >= item.endTime) {
        return;
      }

      // 条件3: 顧客ランクが対象ランクに含まれているかチェック
      const priorityRanks = item.priorityRanks || [];
      const isAllowedRank = priorityRanks.includes(customerRank);

      // 対象ランクでない場合は削除対象
      if (!isAllowedRank) {
        itemsToRemove.push(item.lineIndex);
      }
    });

    return itemsToRemove;
  };

  /**
   * カートから商品を削除
   * @param {Array} lineIndexes - 削除するlineIndexの配列
   */
  const removeCartItems = async (lineIndexes) => {
    try {
      // 削除処理を順次実行
      for (const lineIndex of lineIndexes) {
        await removeCartItem(lineIndex);
      }

      // すべて削除成功後、ページをリロード
      window.location.reload();
    } catch (error) {
      console.error('カートアイテムの削除に失敗しました:', error);
    }
  };

  /**
   * 個別の商品をカートから削除
   * @param {number} lineIndex - 削除するlineIndex
   * @returns {Promise} fetch処理のPromise
   */
  const removeCartItem = async (lineIndex) => {
    // lineIndexは0始まりだが、APIは1始まりなので+1する
    const line = lineIndex + 1;
    const url = `/cart/change?line=${line}&quantity=0`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`カート削除失敗: ${response.status}`);
      }

      return response;
    } catch (error) {
      console.error(`lineIndex ${lineIndex} の削除に失敗しました:`, error);
      throw error;
    }
  };

  // DOMContentLoaded後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartProtection);
  } else {
    initCartProtection();
  }
})();
